import { createElement, isValidElement } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var uid = function uid() {
  return Math.random().toString(36).substring(6);
};
var SVG = function SVG(_a) {
  var _b = _a.animate,
    animate = _b === void 0 ? true : _b,
    animateBegin = _a.animateBegin,
    _c = _a.backgroundColor,
    backgroundColor = _c === void 0 ? '#f5f6f7' : _c,
    _d = _a.backgroundOpacity,
    backgroundOpacity = _d === void 0 ? 1 : _d,
    _e = _a.baseUrl,
    baseUrl = _e === void 0 ? '' : _e,
    children = _a.children,
    _f = _a.foregroundColor,
    foregroundColor = _f === void 0 ? '#eee' : _f,
    _g = _a.foregroundOpacity,
    foregroundOpacity = _g === void 0 ? 1 : _g,
    _h = _a.gradientRatio,
    gradientRatio = _h === void 0 ? 2 : _h,
    _j = _a.gradientDirection,
    gradientDirection = _j === void 0 ? 'left-right' : _j,
    uniqueKey = _a.uniqueKey,
    _k = _a.interval,
    interval = _k === void 0 ? 0.25 : _k,
    _l = _a.rtl,
    rtl = _l === void 0 ? false : _l,
    _m = _a.speed,
    speed = _m === void 0 ? 1.2 : _m,
    _o = _a.style,
    style = _o === void 0 ? {} : _o,
    _p = _a.title,
    title = _p === void 0 ? 'Loading...' : _p,
    _q = _a.beforeMask,
    beforeMask = _q === void 0 ? null : _q,
    props = __rest(_a, ["animate", "animateBegin", "backgroundColor", "backgroundOpacity", "baseUrl", "children", "foregroundColor", "foregroundOpacity", "gradientRatio", "gradientDirection", "uniqueKey", "interval", "rtl", "speed", "style", "title", "beforeMask"]);
  var fixedId = uniqueKey || uid();
  var idClip = fixedId + "-diff";
  var idGradient = fixedId + "-animated-diff";
  var idAria = fixedId + "-aria";
  var rtlStyle = rtl ? {
    transform: 'scaleX(-1)'
  } : null;
  var keyTimes = "0; " + interval + "; 1";
  var dur = speed + "s";
  var gradientTransform = gradientDirection === 'top-bottom' ? 'rotate(90)' : undefined;
  return /*#__PURE__*/createElement("svg", _assign({
    "aria-labelledby": idAria,
    role: "img",
    style: _assign(_assign({}, style), rtlStyle)
  }, props), title ? /*#__PURE__*/createElement("title", {
    id: idAria
  }, title) : null, beforeMask && /*#__PURE__*/isValidElement(beforeMask) ? beforeMask : null, /*#__PURE__*/createElement("rect", {
    role: "presentation",
    x: "0",
    y: "0",
    width: "100%",
    height: "100%",
    clipPath: "url(" + baseUrl + "#" + idClip + ")",
    style: {
      fill: "url(" + baseUrl + "#" + idGradient + ")"
    }
  }), /*#__PURE__*/createElement("defs", null, /*#__PURE__*/createElement("clipPath", {
    id: idClip
  }, children), /*#__PURE__*/createElement("linearGradient", {
    id: idGradient,
    gradientTransform: gradientTransform
  }, /*#__PURE__*/createElement("stop", {
    offset: "0%",
    stopColor: backgroundColor,
    stopOpacity: backgroundOpacity
  }, animate && (/*#__PURE__*/createElement("animate", {
    attributeName: "offset",
    values: -gradientRatio + "; " + -gradientRatio + "; 1",
    keyTimes: keyTimes,
    dur: dur,
    repeatCount: "indefinite",
    begin: animateBegin
  }))), /*#__PURE__*/createElement("stop", {
    offset: "50%",
    stopColor: foregroundColor,
    stopOpacity: foregroundOpacity
  }, animate && (/*#__PURE__*/createElement("animate", {
    attributeName: "offset",
    values: -gradientRatio / 2 + "; " + -gradientRatio / 2 + "; " + (1 + gradientRatio / 2),
    keyTimes: keyTimes,
    dur: dur,
    repeatCount: "indefinite",
    begin: animateBegin
  }))), /*#__PURE__*/createElement("stop", {
    offset: "100%",
    stopColor: backgroundColor,
    stopOpacity: backgroundOpacity
  }, animate && (/*#__PURE__*/createElement("animate", {
    attributeName: "offset",
    values: "0; 0; " + (1 + gradientRatio),
    keyTimes: keyTimes,
    dur: dur,
    repeatCount: "indefinite",
    begin: animateBegin
  }))))));
};
var ContentLoader = function ContentLoader(props) {
  return props.children ? /*#__PURE__*/createElement(SVG, _assign({}, props)) : /*#__PURE__*/createElement(ReactContentLoaderFacebook, _assign({}, props));
};
var ReactContentLoaderFacebook = function ReactContentLoaderFacebook(props) {
  return /*#__PURE__*/createElement(ContentLoader, _assign({
    viewBox: "0 0 476 124"
  }, props), /*#__PURE__*/createElement("rect", {
    x: "48",
    y: "8",
    width: "88",
    height: "6",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "48",
    y: "26",
    width: "52",
    height: "6",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "56",
    width: "410",
    height: "6",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "72",
    width: "380",
    height: "6",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "88",
    width: "178",
    height: "6",
    rx: "3"
  }), /*#__PURE__*/createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }));
};
var ReactContentLoaderInstagram = function ReactContentLoaderInstagram(props) {
  return /*#__PURE__*/createElement(ContentLoader, _assign({
    viewBox: "0 0 400 460"
  }, props), /*#__PURE__*/createElement("circle", {
    cx: "31",
    cy: "31",
    r: "15"
  }), /*#__PURE__*/createElement("rect", {
    x: "58",
    y: "18",
    rx: "2",
    ry: "2",
    width: "140",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "58",
    y: "34",
    rx: "2",
    ry: "2",
    width: "140",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "60",
    rx: "2",
    ry: "2",
    width: "400",
    height: "400"
  }));
};
var ReactContentLoaderCode = function ReactContentLoaderCode(props) {
  return /*#__PURE__*/createElement(ContentLoader, _assign({
    viewBox: "0 0 340 84"
  }, props), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "0",
    width: "67",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "76",
    y: "0",
    width: "140",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "127",
    y: "48",
    width: "53",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "187",
    y: "48",
    width: "72",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "18",
    y: "48",
    width: "100",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "71",
    width: "37",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "18",
    y: "23",
    width: "140",
    height: "11",
    rx: "3"
  }), /*#__PURE__*/createElement("rect", {
    x: "166",
    y: "23",
    width: "173",
    height: "11",
    rx: "3"
  }));
};
var ReactContentLoaderListStyle = function ReactContentLoaderListStyle(props) {
  return /*#__PURE__*/createElement(ContentLoader, _assign({
    viewBox: "0 0 400 110"
  }, props), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "0",
    rx: "3",
    ry: "3",
    width: "250",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "20",
    y: "20",
    rx: "3",
    ry: "3",
    width: "220",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "20",
    y: "40",
    rx: "3",
    ry: "3",
    width: "170",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "0",
    y: "60",
    rx: "3",
    ry: "3",
    width: "250",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "20",
    y: "80",
    rx: "3",
    ry: "3",
    width: "200",
    height: "10"
  }), /*#__PURE__*/createElement("rect", {
    x: "20",
    y: "100",
    rx: "3",
    ry: "3",
    width: "80",
    height: "10"
  }));
};
var ReactContentLoaderBulletList = function ReactContentLoaderBulletList(props) {
  return /*#__PURE__*/createElement(ContentLoader, _assign({
    viewBox: "0 0 245 125"
  }, props), /*#__PURE__*/createElement("circle", {
    cx: "10",
    cy: "20",
    r: "8"
  }), /*#__PURE__*/createElement("rect", {
    x: "25",
    y: "15",
    rx: "5",
    ry: "5",
    width: "220",
    height: "10"
  }), /*#__PURE__*/createElement("circle", {
    cx: "10",
    cy: "50",
    r: "8"
  }), /*#__PURE__*/createElement("rect", {
    x: "25",
    y: "45",
    rx: "5",
    ry: "5",
    width: "220",
    height: "10"
  }), /*#__PURE__*/createElement("circle", {
    cx: "10",
    cy: "80",
    r: "8"
  }), /*#__PURE__*/createElement("rect", {
    x: "25",
    y: "75",
    rx: "5",
    ry: "5",
    width: "220",
    height: "10"
  }), /*#__PURE__*/createElement("circle", {
    cx: "10",
    cy: "110",
    r: "8"
  }), /*#__PURE__*/createElement("rect", {
    x: "25",
    y: "105",
    rx: "5",
    ry: "5",
    width: "220",
    height: "10"
  }));
};
export default ContentLoader;
export { ReactContentLoaderBulletList as BulletList, ReactContentLoaderCode as Code, ReactContentLoaderFacebook as Facebook, ReactContentLoaderInstagram as Instagram, ReactContentLoaderListStyle as List };